import * as React from 'react';
import {
    SelectInput,
    FilterLiveSearch,
    NumberField,
    TextField,
    useLocale,
    Datagrid,
    useTranslate,
    // ReferenceInput,
    // AutocompleteInput,
    EmailField,
    BooleanInput,
    TextInput,
    FormDataConsumer,
    PasswordInput,
    ReferenceField,
    ReferenceArrayField,
    SingleFieldList, ChipField, ReferenceInput, AutocompleteInput,
    useUpdate, useRecordContext, useCreate,
} from 'react-admin';
// import {RowForm} from "@react-admin/ra-editable-datagrid";
import {useForm} from "react-final-form";
import ListComponentAdmin from "../../_common/ListComponentAdmin";
import TableActions from "../../_common/TableActions";
import useMyStyles from "../../utils/useMyStyles";
import {CardContent, DialogContent, DialogContentText, Typography, useMediaQuery} from "@material-ui/core";
import CardComp from "../../_common/Asside/CardComp";
import {
    DateFieldComp,
    FilterDataAside,
    //NumberInputFloatComp,
    UserInfo,
} from "../../_common/CompReact";
// import {Box} from "@mui/material";
import TrueFalseFilters from "../../_common/TrueFalseFilters";
import {
    choicesContractorType,
    choicesCreateFromDataRequest,
    choicesStatusRequest,
    getStatusById
} from "../../_constants/choices";
import SelectAndSaveChoices from "../../_common/SelectAndSaveChoices";
import {useSelectedColumns} from "@react-admin/ra-preferences";
import {Dialog} from "@mui/material";
import RowFormCustom from "../../_common/DependenciesComp/RowFormCustom";
import {Box, Grid} from "@mui/material";
import MyEditableDatagridForReference from "../../_common/MyEditableDatagridForReference";
import {validateEmailReq, validateReq} from "../../_constants/validateTable";
import {canAccess2} from "../../utils/canAccess2";
// import {useEffect} from "react";
// import SaveIcon from '@mui/icons-material/Save';
// import PasswordIcon from '@mui/icons-material/Password';
import LockResetIcon from '@mui/icons-material/LockReset';
import {useEffect, useMemo, useState} from "react";
import CroppedLongField from "../../_common/CroppedLongField";
import PhoneField, {formatPhoneNumber} from "../../_common/PhoneField";
import Asynchronous2 from "../../_common/AsynchronousRequests2";
import {
    GetArrayFieldFromResource,
    GetFieldFromChoice, getFieldFromResource,
    GetFieldFromResource
} from "../../pagesZenit/createPartner/Partner";
import Button from '@mui/material/Button';
import {Menu, MenuItem} from '@mui/material'//"@material-ui/core";

import {Link} from 'react-admin';
// import {stringify} from "query-string";
// import products from "../dProducts";
import moment from "moment/moment";
import windowWidth, {windowHeight} from "../../_common/WindowWidth";
import DynamicFiltersChoices from "../../_common/DynamicFiltersChoices";
import Alert from "@material-ui/lab/Alert";
import get from 'lodash/get';
import {useTheme} from "@mui/material/styles";
import Chip from "@material-ui/core/Chip";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import {EditAddress} from "../../pagesZenit/createPartner/EditAddress";
import {getRequestOverpass} from "../../_constants/requestOverpass";
import {getCustomerPricingProperty, nominatimOpenStreetMap} from "../../_common/CompForApi/utilsAPI";
import validate from "validate.js";
import {fetchJson as httpClient} from "../../utils/keycloak";
import config from "../../utils/config";
import {startOfWeek} from "date-fns";

const schemaAuto = {
    deliveries: {
        presence: {allowEmpty: false, message: 'is required'},
    },
    customers: {
        presence: {allowEmpty: false, message: 'is required'},
    },
    area: {
        presence: {allowEmpty: false, message: 'is required'},
    },
    /*region: {
        presence: {allowEmpty: false, message: 'is required'},
    },*/
    point: {
        presence: {allowEmpty: false, message: 'is required'},
    },
    street: {
        presence: {allowEmpty: false, message: 'is required'},
    },
    house: {
        presence: {allowEmpty: false, message: 'is required'},
        // email: true,
        length: {
            minimum: 1,
            maximum: 256,
        },
    },
    lat: {
        presence: {allowEmpty: false, message: 'is required'},
        // email: true,
    },
    lon: {
        presence: {allowEmpty: false, message: 'is required'},
    },
    name: {
        presence: {allowEmpty: false, message: 'is required'},
        // email: true,
        length: {
            minimum: 2,
            maximum: 256,
        },
    },

};
const schemaHand = {
    deliveries: {
        presence: {allowEmpty: false, message: 'is required'},
    },
    customers: {
        presence: {allowEmpty: false, message: 'is required'},
    },
    area_hand: {
        presence: {allowEmpty: false, message: 'is required'},
    },
    region_hand: {
        presence: {allowEmpty: false, message: 'is required'},
    },
    point_hand: {
        presence: {allowEmpty: false, message: 'is required'},
    },
    street_hand: {
        presence: {allowEmpty: false, message: 'is required'},
    },
    house: {
        presence: {allowEmpty: false, message: 'is required'},
        // email: true,
        length: {
            minimum: 1,
            maximum: 256,
        },
    },
    lat: {
        presence: {allowEmpty: false, message: 'is required'},
        // email: true,
    },
    lon: {
        presence: {allowEmpty: false, message: 'is required'},
    },
    name: {
        presence: {allowEmpty: false, message: 'is required'},
        // email: true,
        length: {
            minimum: 2,
            maximum: 256,
        },
    },

};

function iniAddress(record) {
    return {
        expanded: true,
        values: {
            id: null,
            auto_address: false,
            address: '',
            house: record?.building,
            flat: record?.apartment,
            area: null,
            region: null,
            point: null,
            street: null,
            area_hand: record?.region,
            region_hand: record?.district,
            point_hand: record?.locality,
            street_hand: record?.street,
            confirmed: false,
            disabled: false,
            name: record?.address_title,
            lat: 0,
            lon: 0,
            comment: '',
            placement: '',
            deliveries: [],
            customers: [],
        },
        is_valid: false,
        touched: {},
        error: {},
        error_double: {},
    }
}

let pause = false
export const EditAddressDialog = (props) => {//https://overpass-turbo.eu/index.html
    //const classes = useMyStyles();
    const {record, setRefreshData, setOpenAddress, partnerData} = props;
    const translate = useTranslate();
    const isSmall = useMediaQuery(function (theme) {
        return theme.breakpoints.down('sm'); //xs  sm
    });

    const [form, setForm] = React.useState({
        address: {address: iniAddress(record)},
    });
    const [processing, setProcessing] = useState(false);
    const [areas, setAreas] = React.useState([]);
    const [pricingProperty, setPricingProperty] = React.useState([]);
    const [mixCustomers, setMixCustomers] = React.useState([]);
    const [errSaveAddress, setErrSaveAddress] = React.useState(null);


    useEffect(() => {
        if (!pause) {
            pause = true
            setTimeout(function () {
                pause = false
            }, 2);
            let address = JSON.parse(JSON.stringify(form.address))
            Object.entries(address).map((item, ind) => {
                if (item[1].values.auto_address)
                    item[1].error = validate(item[1].values, schemaAuto);
                else item[1].error = validate(item[1].values, schemaHand);
                item[1].error = item[1].error ? item[1].error : {}
                item[1].is_valid = Object.keys(item[1].error).length === 0 ? true : false
            })
            //address.is_valid = validateAll > 0 ? false : true
            setForm(form => ({
                ...form,
                address: address
            }));
        }

    }, [form.address]); // eslint-disable-line

    useEffect(() => {
        async function areaData() {
            // You can await here
            let req = getRequestOverpass('getAreas', '', '', '')
            const getAreas = await nominatimOpenStreetMap(req);
            let arr = []
            if (getAreas) {
                getAreas.forEach(it => {
                    if (it?.tags['ISO3166-2']) {
                        if (it.tags['ISO3166-2'].indexOf('UA') >= 0) {
                            arr.push({
                                id: it.id,
                                name: it.tags.name,
                                name_ori: it.tags.name,
                                iso: it.tags['ISO3166-2'],
                                tag: it.tags
                            })
                        }
                    }
                })
                arr.sort(function (a, b) {
                    if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                    if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                    return 0;
                })
            }
            setAreas(arr)
        }

        const getCustomers = async (record) => {
            let url = config.apiUrl + `api/react-admin/main/Customers?filter_customers_partner_id=${record.partner}&limit=100&ordering=-id&skip=0`
            try {
                const response = await httpClient(url);
                if (response.status >= 200 && response.status <= 300) {
                    const {json} = response
                    const {results} = json || {}
                    if (Array.isArray(results)) {
                        setMixCustomers(results)
                        let arrCust = []
                        results.forEach((it) => {
                            if (record.partner_customers.indexOf(it.id) >= 0) arrCust.push(it)
                        })
                        handleChangeSel('address', 'address', 'customers', arrCust)
                    } else setMixCustomers([])
                } else {
                }
            } catch (err) {
            } finally {
            }
        }
        // getCustomerPricingProperty(setPricingProperty)
        getCustomers(record)
        areaData();
    }, [record]);// eslint-disable-line

    const [create, state] = useCreate();
    useEffect(() => {
        const getRequestChange = async (record) => {
            setErrSaveAddress(null)
            let url = config.apiUrl + `api/react-admin/main/AccountRequest/${record.id}`
            let data = JSON.parse(JSON.stringify(record))
            data.request_status = 'CLOSED'
            try {
                // const response = await httpClient(url);
                const response = await httpClient(`${url}`, {
                    method: 'PUT',
                    body: JSON.stringify(data)
                });
                if (response.status >= 200 && response.status <= 300) {
                    // const {json} = response
                    // const {results} = json || {}
                    setOpenAddress(false)
                    setRefreshData(true)
                } else {
                    setErrSaveAddress('Undefined error')
                }
            } catch (err) {
                setErrSaveAddress(err.message)
            } finally {
            }
        }
        if (state.loading) setErrSaveAddress(null)
        if (!state.loading && state.error) setErrSaveAddress(state.error.message)
        if (state.loaded) {
            getRequestChange(record)
        }
    }, [state]); // eslint-disable-line

    const handleSaveAddress = () => {
        let data = {
            "partner": record.partner,
            "area": form.address.address.values.auto_address
                ? form.address.address.values.area.name
                : form.address.address.values.area_hand,
            "region": form.address.address.values.auto_address
                ? form.address.address.values.region.name
                : form.address.address.values.region_hand,
            "point": form.address.address.values.auto_address
                ? form.address.address.values.point.name
                : form.address.address.values.point_hand,
            "street": form.address.address.values.auto_address
                ? form.address.address.values.street.name
                : form.address.address.values.street_hand,

            "auto_address": form.address.address.values.auto_address,
            "confirmed": form.address.address.values.confirmed,
            "disabled": form.address.address.values.disabled,
            "address": form.address.address.values.address,
            "lat": form.address.address.values.lat,
            "lon": form.address.address.values.lon,
            "house": form.address.address.values.house,
            "flat": form.address.address.values.flat,
            "name": form.address.address.values.name,

            "deliveries": form?.address?.address?.values?.deliveries?.map(d => d.id) || [],
            "customers": form?.address?.address?.values?.customers?.map(d => d.id) || [],

            "comment": form.address.address.values.comment,
            "placement": form.address.address.values.placement
        }
        create('partnerAddress', data)
    }

    const handleSetForm = (snap, index, name, val) => {
        if (index) {
            setForm(form => ({
                ...form,
                [snap]: {
                    ...form[snap],
                    [index]: {
                        ...form[snap][index],
                        values: {
                            ...form[snap][index].values,
                            [name]: val,
                        },
                    }
                }
            }));
        } else {
            setForm(form => ({
                ...form,
                [snap]: {
                    ...form[snap],
                    values: {
                        ...form[snap].values,
                        [name]: val,
                    },
                },
            }));
        }
    }
    const handleChangeSel = (snap, index, name, v) => {
        //console.log(index, name, '=====>', v)
        let val = v;
        handleSetForm(snap, index, name, val)
        console.log(snap, index, name, '=====>', val)
    };
    const handleChangeText = (snap, index, name, v, countDigit = 0) => {
        let val = v.target.value
        if (countDigit) val = v.target.value.replace(/\D/g, '')
        handleSetForm(snap, index, name, val)
        // console.log(snap, index, name, '=====>', val)
    };
    const handleChangeCheck = (snap, index, name, v) => {
        //console.log(index, name, '=====>', v)
        let val = v.target.checked;
        handleSetForm(snap, index, name, val)
        //console.log(snap, index, name, '=====>', val)
    };
    return (
        <>
            <DialogContent>
                {errSaveAddress &&
                    <Typography variant="body" color="error">
                        ERROR: <b>{errSaveAddress}</b>
                    </Typography>
                }
                <Box display={'grid'}>
                    <Typography variant="body">
                        <b>{`${translate('Creating a delivery address for partner')} ${partnerData ? partnerData.name : '---'}`}</b>
                    </Typography>
                    <Typography variant="body">
                        <b>{`${translate('Request No')} ${record.id} (${moment(record.created).format('DD.MM.YYYY')})`}</b>
                    </Typography>
                </Box>
                <DialogContentText id="alert-dialog-description" style={{width: isSmall ? 400 : 1000}}>
                    <Box fullWidth style={{width: isSmall ? 400 : 1000}}>
                        <EditAddress
                            form={form}
                            index={'address'}
                            processing={processing}
                            setProcessing={setProcessing}
                            mixCustomers={mixCustomers}
                            handleSetForm={handleSetForm}
                            handleChangeSel={handleChangeSel}
                            handleChangeText={handleChangeText}
                            handleChangeCheck={handleChangeCheck}
                            areas={areas}
                            labelForm={''}
                        />
                    </Box>
                </DialogContentText>
            </DialogContent>
            <DialogActions style={{padding: 24}}>
                <Box flex={1} textAlign={'start'}>
                    <Button
                        disabled={!form.address.address.is_valid}
                        variant="contained"
                        onClick={handleSaveAddress}
                        color="primary"
                        // autoFocus
                    >
                        {translate('Save')}
                    </Button>
                </Box>
                <Box flex={1} textAlign={'end'}>
                    <Button
                        variant="outlined"
                        onClick={(event) => {
                            setOpenAddress(false)
                        }}
                        color="error"
                        autoFocus
                    >
                        CLOSE
                    </Button>
                </Box>
            </DialogActions>
        </>
    )
}